// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"9b2821df","232":"c0d811ae","237":"4e4da19e","357":"c9c49a70","516":"c270492e","526":"667d0c29","653":"5da85c8b","675":"c984563d","753":"c504283b","854":"b1549e7f","872":"0700fdd5"}[chunkId] + ".chunk.js";
};